import { WatchAction, SaveWatchEmbeddedData } from './watchActions'
import * as watchConstants from './watchConstants'
import { isPrdEnvironment } from '../../utils/platform'

/* ------------- State ------------- */
type WatchStateType = typeof initialState
export interface WatchState extends WatchStateType {}

export const initialState = {
  eid: '',
  imei: '',
  primaryDeviceIccid: '',
}

/* ------------- Reducers ------------- */
const parseEmbeddedData = (state: WatchState, action: SaveWatchEmbeddedData): WatchState => {
  const { params: embeddedParams, query } = action
  const { injectAppleWatchData } = query

  const isQueryParamsInjected = !isPrdEnvironment() && injectAppleWatchData === 'true'
  const isApplePostParamsPresent = !!embeddedParams['secondary-device-active']

  if (!isApplePostParamsPresent && !isQueryParamsInjected) return state

  const appleWatchData = isApplePostParamsPresent ? embeddedParams['secondary-device-active'] : query

  return {
    ...state,
    eid: appleWatchData.eid,
    imei: appleWatchData['device-imei'],
    primaryDeviceIccid: appleWatchData['primary-device-iccid'],
  }
}

export default (state: WatchState = initialState, action: WatchAction): WatchState => {
  switch (action.type) {
    case watchConstants.SAVE_WATCH_EMBEDDED_DATA:
      return parseEmbeddedData(state, action)
    default:
      return state
  }
}
